import { useMutation } from '@tanstack/react-query';

import {
  postBooking,
  putProposal,
  updateTripCurrency,
} from '../clients/bookings';

const BookingActions = {
  booking: {
    makeBooking(tripData) {
      return postBooking(tripData);
    },
  },
};

export default BookingActions;

export const useUpdateProposalMutation = () => {
  const mutation = useMutation({
    mutationFn: ({
      bookingId,
      preferredCurrency,
    }: {
      bookingId: string;
      preferredCurrency: string;
    }) => putProposal(bookingId, preferredCurrency),
  });
  return mutation;
};

export const useUpdateTripCurrencyMutation = () => {
  const mutation = useMutation({
    mutationFn: ({
      bookingId,
      currency,
    }: {
      bookingId: string;
      currency: string;
    }) => updateTripCurrency(bookingId, currency),
  });
  return mutation;
};
